<template>
  <div class="sidebar" v-show="!hideSiteLists">
    <div class="sidebar-loading" v-if="isLoading">
      <loading-placeholder class="loading-placeholder-image"></loading-placeholder>
    </div>
    <div class="sidebar-wrapper" v-if="!isLoading && !hideSiteLists">
      <div class="sidebar-header">
        <b-dropdown id="ddown1" class="site-dropdown" no-caret>
          <template slot="button-content">
            <span class="group-name">{{selectedGroupName}}
              <span>
                <down-icon class="down-caret"></down-icon>
              </span>
            </span>
          </template>
          <b-dropdown-item @click="selectGroup({groupID:'all'})">
            All Sites
          </b-dropdown-item>
          <b-dropdown-item @click="selectGroup(group)" v-for="group in groups" :key="group.groupID">
            {{group.name}}
          </b-dropdown-item>
        </b-dropdown>
        <span @click="openManageGroups($event)" class="groups-btn" v-b-tooltip.hover title="Manage groups">
          <group-icon class="icon-default groups"></group-icon>
        </span>
      </div>
      <div class="sidebar-content" id="sidebarcontent">
        <div class="search-container relative">
          <input type="text" class="search sites" v-model="searchText" placeholder="type to filter" name="" />
          <magnifier-icon class="lens-icon"></magnifier-icon>
        </div>
        <div class="sidebar-site-list">
          <div v-for="site in sites" :key="site.siteID" class="site-item" v-if="sites.length!=0" v-bind:class="{active:popoverMap[site.siteID]}">

            <div class="site-name-wrapper" :id="'popover_'+site.siteID" @mouseenter="showPopover(site.siteID)" @mouseleave="hidePopover(site.siteID)">
              <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
              <span class="site-name" v-bind:class="{broken:site.connectionStatus ==='0',maintenance:site.connectionStatus ==='2'}" ref="button" variant="primary">
                {{site.name}}</span>
              <site-pophover :popoverMap="popoverMap" @action="processAction" :site="site" :contentHoverMap="contentHoverMap">
              </site-pophover>
            </div>
          </div>
          <div v-if="sites.length==0">
            <empty-placeholder v-if="searchText.length>0" type="neutral" v-bind="placeholderProps"></empty-placeholder>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-footer" style="height: 51px;" v-if="!isLoading && !hideSiteLists">
        <b-button @click="showAddSite" class="ml-2" v-if="isAddSiteAvailable()"><plus-icon class="plus"></plus-icon>Add Site</b-button>
        <b-button @click="emitHideSiteLists" class="toggle" v-b-tooltip.hover title="Hide site lists"><left-arrow-icon></left-arrow-icon></b-button>
    </div>
    <addsite ref="addSite" v-if="!isLoading"></addsite>
    <edit-site ref="editsite" :site="currentSite"></edit-site>
    <server-info ref="serverinfo" :site="currentSite"></server-info>
    <maintenance-mode ref="maintanancemode" :site="currentSite"></maintenance-mode>
    <manage-groups ref="managegroups"></manage-groups>
    <remove-site ref="removesite" :site="currentSite"></remove-site>
    <readd-site ref="readdsite" :site="currentSite"></readd-site>
    <create-backup ref="createBackup" :siteId="currentSite.siteID"></create-backup>
    <custom-branding ref="customBranding" :site="currentSite" v-if="isAddonInstalled('clientPluginBranding')"></custom-branding>
    <create-staging ref="createStaging" :site="currentSite" v-if="isAddonInstalled('staging')"></create-staging>
    <staging-confirmation-modal ref="confirmation" :site="currentSite" v-if="isAddonInstalled('staging')"></staging-confirmation-modal>
    <add-existing-staging ref="existingStaging" :site="currentSite" v-if="isAddonInstalled('staging')" ></add-existing-staging>
    <update-staging-modal v-if="isAddonInstalled('staging')"></update-staging-modal>

  </div>
</template>


<script>
import Vue from 'vue';
import _ from 'lodash';
import addsite from './modals/AddSite';
import SiteInfo from './siteInfo/SiteInfo';
import EditSite from './modals/EditSite';
import ServerInfo from './modals/ServerInfo';
import MaintenanceMode from './modals/MaintenanceMode';
import ManageGroups from './modals/ManageGroups';
import RemoveSite from './modals/RemoveSite';
import ReaddSite from './modals/ReAddSite';
import CreateBackup from './protect/CreateBackup';

import DownIcon from '../assets/down.svg';
import TickIcon from '../assets/tick.svg';
import MagnifierIcon from '../assets/lens.svg';
import GroupIcon from '../assets/groups.svg';
import InfoIcon from '../assets/info.svg';
import PlusIcon from '../assets/plus2.svg';
import LeftArrowIcon from '../assets/leftarrow.svg';

import EmptyPlaceholder from './Common/EmptyPlaceholder';
import SitePophover from './Common/sitePopHover';
import LoadingPlaceholder from '../assets/loadingplaceholder.svg';
import { EventBus } from '../event/event-bus.js';


export default {
  name: 'sidebar',
  props: ['isLoading'],
  data() {
    return {
      searchText: '',
      selectedGroupName: 'All Sites',
      hideSiteLists: false,
      currentSite: {},
      popoverMap: {},
      contentHoverMap: {},
      serverURL: window.serverURL,
      placeholderProps: {
        text: () => {
          return `Bummer, there are no websites that match. Try typing fewer characters.`;
        },
        type: 'neutral'
      }
    };
  },
  components: {
    addsite,
    SiteInfo,
    EditSite,
    ServerInfo,
    MaintenanceMode,
    ManageGroups,
    DownIcon,
    MagnifierIcon,
    GroupIcon,
    InfoIcon,
    TickIcon,
    RemoveSite,
    LoadingPlaceholder,
    ReaddSite,
    EmptyPlaceholder,
    CreateBackup,
    PlusIcon,
    LeftArrowIcon,
    SitePophover,
    CustomBranding: () =>
      import(/* webpackChunkName: 'ClientPluginBranding/index' */ './addons/ClientPluginBranding/index').then(
        ({ CustomBranding }) => CustomBranding
      ),
    CreateStaging: () =>
      import(/* webpackChunkName: 'Staging/index' */ './addons/Staging/index').then(
        ({ createStaging }) => createStaging
      ),  
    AddExistingStaging: () =>
      import(/* webpackChunkName: 'Staging/index' */ './addons/Staging/index').then(
        ({ addExistingStaging }) => addExistingStaging
      ),
    StagingConfirmationModal :() => 
      import(/* webpackChunkName: 'Staging/index' */ './addons/Staging/index').then(
        ({ confirmationModal }) => confirmationModal
      ),
    UpdateStagingModal :() => 
      import(/* webpackChunkName: 'Staging/index' */ './addons/Staging/index').then(
        ({ updateStagingModal }) => updateStagingModal
      ),            
    
  },
  mounted() {
    // this.serverInfo(this.sites[0]);
    // this.openManageGroups();
    EventBus.$on('show-site-lists', value => {
      this.hideSiteLists = value;
    });
    EventBus.$on('open-edit-modal', value => {
      this.editsite(value.site);
    });
  },
  computed: {
    sites() {
      let groupSites = _.values(this.$store.getters.getSitesByIdGroupId);
      let sites = groupSites.filter(site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      return _.sortBy(sites, [site => site.name.toLowerCase()]);
    },
    selectedSitesCount() {
      return this.$store.getters.selectedSitesCount;
    },
    groups() {
      let groups =  this.$store.getters.getGroups;
      return _.sortBy(groups, [group => group.name.toLowerCase()]);
    },
    appInfo() {
      return this.$store.getters.getAppInfo;
    },
    currentUserInfo(){
      return this.$store.getters.getCurrentUserInfo;
    }
  },
  watch: {
    groups(newGroups) {
      let currentGroupId = this.$store.getters.getCurrentGroupId;
      if (currentGroupId == 'all') {
        return;
      }
      let index = _.findIndex(newGroups, { groupID: currentGroupId });
      if (index === -1) {
        this.selectGroup({ groupID: 'all' });
      }
    }
  },
  methods: {
    toggleSite(site, isSelected) {
      this.$store.commit({
        type: 'SELECT_SITE',
        site: site,
        value: isSelected
      });
    },
    selectAll(groups) {
      this.$store.commit({
        type: 'SELECT_SITES',
        value: true
      });
    },
    selectNone(groups) {
      return this.$store.commit({
        type: 'SELECT_SITES',
        value: false
      });
    },
    openAdminInNewTab() {
      let cacheValue = Date.now();
      window.open(
        `${window.serverURL}?action=loadSite&siteID=${
          this.currentSite.siteID
        }&cache=${cacheValue}`,
        '_blank'
      );
    },
    selectGroup(group) {
      if (group.groupID === 'all') {
        this.selectedGroupName = 'All Sites';
      } else {
        this.selectedGroupName = group.name;
      }
      this.$store.commit({
        type: 'SET_CURRENT_GROUP',
        value: group.groupID
      });
    },
    setPopoverMap(siteID, value) {
      Vue.set(this.popoverMap, siteID, value);
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    setContentHoverMap(siteID) {
      this.contentHoverMap[siteID] = true;
    },
    closePopover(siteID) {
      this.contentHoverMap[siteID] = false;
      this.$root.$emit('bv::hide::popover', 'popover_' + siteID);
    },
    processAction(payload) {
      this.$root.$emit('bv::hide::popover');
      switch (payload.action) {
        case 'edit':
          this.editsite(payload.site);
          break;
        case 'serverInfo':
          this.serverInfo(payload.site);
          break;
        case 'maintenanceMode':
          this.maintananceMode(payload.site);
          break;
        case 'viewBackups':
          this.viewBackups(payload.site);
          break;
        case 'backupNow':
          this.backupNow(payload.site);
          break;
        case 'reloadData':
          this.sendReloadData(payload.site);
          break;
        case 'removeSite':
          this.removeSite(payload.site);
          break;
        case 'reAddSite':
          this.reAddSite(payload.site);
          break;
        case 'customBranding':
          this.customBranding(payload.site);
          break;
        case 'createStagingSite':
          this.createStagingSite(payload.site);
          break;
        case 'addExistingStagingSite':
          this.addExistingStagingSite(payload.site);
          break;
        case 'stagingDeleteSite':
          this.stagingAction(payload);
          break;
        case 'stagingToLive':
          this.stagingAction(payload);
          break;
        case 'liveToStaging':
          this.stagingAction(payload);     
          break;
        case 'editStaging':
          this.editStaging(payload);     
          break;        

      }
    },
    editsite(site) {
      this.currentSite = site;
      this.$refs.editsite.$refs.editsitemodal.show();
    },
    serverInfo(site) {
      this.currentSite = site;
      this.$refs.serverinfo.$refs.serverinfomodal.show();
    },
    maintananceMode(site) {
      this.currentSite = site;
      this.$refs.maintanancemode.$refs.maintanancemodemodal.show();
    },
    openManageGroups($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      this.$refs.managegroups.$refs.managegroups.show();
    },
    showPopover(siteID) {
      this.$root.$emit('bv::hide::popover');
      this.$root.$emit('bv::show::popover', 'popover_' + siteID);
    },
    hidePopover(siteID) {
      setTimeout(() => {
        if (!this.contentHoverMap[siteID]) {
          this.$root.$emit('bv::hide::popover', 'popover_' + siteID);
        }
      }, 300);
    },
    removeSite(site) {
      this.currentSite = site;
      this.$refs.removesite.$refs.removesite.show();
    },
    reAddSite(site) {
      this.currentSite = site;
      this.$refs.readdsite.$refs.reAddSite.show();
    },
    gotoPageWithQuery(route) {
      this.$router.push({ name: 'Manage', params: { slug: route.page },  query: { show: route.query } });
    },
    viewBackups(site) {
      this.gotoPageWithQuery({page:'backups', query:site.siteID});
      EventBus.$emit('view-backups', site.name);
    },
    backupNow(site) {
      this.currentSite = site;
      this.$refs.createBackup.$refs.createBackupModal.show();
    },
    sendReloadData(site) {
      let payload = {};
      payload.action = 'getStats';
      payload.args = {
        siteIDs: [site.siteID]
      };
      payload.requiredData = {
        getSitesV3: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getSitesBackupsV3: 1,
        getClientUpdateAvailableSiteIDs: 1,
        getAdditionalStatsV3:1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.$store.commit('SET_STATE_VARIABLE', {
          variable: 'currentReloadActionID',
          value: response.actionResult.actionID
        });
      });
    },
    showAddSite() {
      this.$refs.addSite.$refs.AddSiteModel.show();
    },
    emitHideSiteLists(){
      this.hideSiteLists = true;
      EventBus.$emit('hide-site-lists', true);
    },
    customBranding(site){
      this.currentSite = site;
      this.$refs.customBranding.$refs.customBrandingModel.show();
    },
    createStagingSite(site){
      this.currentSite = site;
      this.$refs.createStaging.$refs.createStagingModel.show();

    },
    addExistingStagingSite(site){
      this.currentSite = site;
      this.$refs.existingStaging.$refs.existingStagingModel.show();
    },
    isAddonInstalled(slug) {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return _.indexOf(installedAddons,slug) > -1;
    },
    isAddSiteAvailable(){
      if (this.currentUserInfo.accessLevel == 'admin'){
        return true;
      }
      return _.indexOf(this.currentUserInfo.permissions.access,'addEditRemoveSite') > -1
    },
    stagingAction(payload){
      this.currentSite = payload.site;
      this.currentSite['action'] = payload.action;
      this.$refs.confirmation.$refs.stagingConfirmationModal.show();
    },
    editStaging(payload){
      this.currentSite = payload.site;
      this.currentSite['action'] = payload.action;
      this.$refs.createStaging.$refs.createStagingModel.show();
    }
  }
};
</script>

<style scoped>
.accordion-icon {
  position: absolute;
  top: 6px;
  right: 0;
  width: 50px;
}
.site-dropdown {
  width: 100%;
}
.site-dropdown >>> button {
  width: 100%;
  text-align: left;
  color: black;
  background: white;
  border: none;
  outline: none;
}
</style>
